import { render } from "./ViewNotification.vue?vue&type=template&id=42581d27&scoped=true"
import script from "./ViewNotification.vue?vue&type=script&lang=js"
export * from "./ViewNotification.vue?vue&type=script&lang=js"

import "../styles/notification.scss?vue&type=style&index=0&id=42581d27&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42581d27"]])

export default __exports__